import { render } from "./QuizCreate.vue?vue&type=template&id=576abc0e&scoped=true"
import script from "./QuizCreate.vue?vue&type=script&lang=js"
export * from "./QuizCreate.vue?vue&type=script&lang=js"

import "./QuizCreate.vue?vue&type=style&index=0&id=576abc0e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576abc0e"]])

export default __exports__